import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';
import { borders, spaces } from '@99designs/emu/settings';

const Wrapper = styled.div`
    padding: ${spaces['2bu']};
    border-radius: ${borders.borderRadiuses.medium}px;
    border: ${borders.content};

    ${mediaQuery.only('small')} {
        padding: ${spaces['2bu']} ${spaces['1bu']};
    }
`;

interface Props {
    children: React.ReactNode;
}

const BriefSectionWrapper = ({ children }: Props) => <Wrapper>{children}</Wrapper>;

export default BriefSectionWrapper;
